import { MutableRefObject } from 'react';

import { TranslatableText } from '@dreryk/react-common';
import {
   ContentCopyIcon,
   IconSize,
   IconWrapper,
   Tooltip,
   TooltipPlacement,
   TooltipTrigger,
} from '@dreryk/react-components';

import { useVisitFormSyncing } from '../../visit/form/VisitFormSynchronization.hooks';

type HistoricalVisitItemHeaderCopyIconProps = {
   readonly onClick: VoidFunction;
   readonly tooltipText: TranslatableText;
   readonly visible: boolean;
   readonly backdropElementRef?: MutableRefObject<HTMLElement | null>;
};

export const HistoricalVisitItemHeaderCopyIcon = (
   props: HistoricalVisitItemHeaderCopyIconProps
): JSX.Element | null => {
   const visitFormSyncing = useVisitFormSyncing();
   if (!props.visible) {
      return null;
   }

   return (
      <Tooltip
         content={props.tooltipText}
         disabled={!props.tooltipText}
         trigger={TooltipTrigger.HOVER}
         placement={TooltipPlacement.LEFT}
         testId={'copy'}
      >
         <IconWrapper
            size={IconSize.SMALL}
            onClick={props.onClick}
            testId={'copy'}
            disabled={visitFormSyncing}
            backdropElementRef={props.backdropElementRef}
         >
            <ContentCopyIcon />
         </IconWrapper>
      </Tooltip>
   );
};
